// extracted by mini-css-extract-plugin
module.exports = {"container":"_2-X_MQt-3nfgeA11oPKyAK","cancelBtn":"_2GwynDtqaP53SkGRvg6ZbT","icon":"_1qPryOaMpwsIKSfH1Z3Ym8","saveBtn":"_2zxkR7XQxSnAth1ND_LfFH"};